export default __webpack_public_path__ + "static/media/Wanja_glad.f8c83085.jpg";